import { crudUtil } from "./axiosCRUD";
import { AI, teleprompter as teleprompterRoute } from "../constants/apiRoutes";

// Types for teleprompter API
export interface ITeleprompterRequest {
  type: "teleprompter";
  Prompt: string;
  tone?: string;
  duration?: string;
}

export interface ITeleprompterResponse {
  success: boolean;
  response: string;
}

// Generate teleprompter content
export async function generateTeleprompterContent({
  prompt,
  tone = "professional",
  duration = "60s",
  abortController,
}: {
  prompt: string;
  tone?: string;
  duration?: string;
  abortController?: AbortController;
}): Promise<ITeleprompterResponse> {
  const requestData: ITeleprompterRequest = {
    type: "teleprompter",
    Prompt: prompt,
    tone,
    duration,
  };

  const response = await crudUtil.post<ITeleprompterResponse>(
    `${AI}${teleprompterRoute}`,
    requestData,
    {
      signal: abortController?.signal,
    }
  );

  return response;
}
